import styled from 'styled-components'

export const Container = styled.div`
  flex: 1 1 auto;
  background-color: #f5f5f5;
  padding: 24px 56px;
  overflow: hidden;

  @media screen and (max-width: 820px) {
    padding: 0;
    background: white;
  }
`

export const FeedContainer = styled.div`
  padding-top: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  overflow: auto;
  height: 97%;
  padding-bottom: 40px;
  box-sizing: border-box;
  align-content: flex-start;
  justify-content: flex-start;
  position: relative;

  @media screen and (max-width: 820px) {
    padding: 16px;
    justify-content: flex-start;
  }

  @media screen and (max-width: 715px) {
    padding: 0;
    justify-content: flex-start;
    height: auto;
  }

  @media screen and (max-width: 600px) {
    padding-top: 20px;
    justify-content: center;
  }
`
